export default "__VITE_ASSET__BNJKtdR5__"